import React, {useEffect, useState} from 'react';
import {useHistStyles} from './inpatientHistoryList';
import _ from 'lodash';
import ApartmentIcon from '@mui/icons-material/Apartment';
import clsx from 'clsx';
import {IconButton} from '@mui/material';
import {useTranslation} from 'react-i18next';
import AttendanceChip from '../../../components/notes/component/attendanceChip';
import {getAdmissionStartDate} from '../../../util/patientUtil';
import AttendanceTimelineHistory from '../../../components/ui/timeline/attendanceTimelineHistory';
import AgyleButton from '../../../components/ui/buttons/agyleButton';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import {hasOneOfPermission, Permissions} from '../../../store/reducers/user';
import {useDispatch, useSelector} from 'react-redux';
import {getConfig} from '../../../util/configUtil';
import {ctxSplitScreen} from '../../../store/reducers/patientContext';

const HistAttendanceField = ({admission, expandFromParent, onOpen, disabledAdmission}) => {
    const {t} = useTranslation();
    const classes = useHistStyles();
    const dispatch = useDispatch();

    const [expand, setExpand] = useState(false);
    const isED = admission?.admission?.attendanceType === 'E';

    const splitScreen = useSelector(ctxSplitScreen);
    const isSSEnabled = splitScreen?.enabled;

    const canView = dispatch(hasOneOfPermission([Permissions.AGYLE_CAN_VIEW_ATTENDANCE_HISTORY, Permissions.AGYLE_CAN_EDIT_ATTENDANCE_HISTORY]));

    // Configs
    const uhdMaps = getConfig('modules.map.customMapConfig', []);

    useEffect(() => {
        setExpand(expandFromParent);
    }, [expandFromParent]);

    const getHeader = () => {
        let facility = null;
        if (admission?.admission?.facility) {
            const hospital = _.find(uhdMaps, map => map?.hospitalId === admission?.admission?.facility);
            if (hospital) {
                facility = (
                    <div className={classes.divRow} style={{gap: 5}}>
                        <ApartmentIcon/>

                        <span>
                            {hospital?.name}
                        </span>
                    </div>
                );
            }
        }

        const age = getAdmissionStartDate(admission?.admission)?.diff(admission?.patient?.dob, 'years');

        return (
            <div className={clsx(classes.divRow, classes.block)} style={{gap: 10, flexWrap: isSSEnabled ? 'wrap' : 'nowrap'}}>
                <AttendanceChip admission={admission.admission}/>

                {facility &&
                    <div className={clsx(classes.divRow)}>
                        {facility}
                    </div>
                }

                <span className={classes.headerText}>
                    {admission?.admission?.attendanceId || '-'}
                </span>

                <span className={classes.headerText}>
                    {t('Age at visit:')} {age}
                </span>

                <span className={classes.headerText}>
                    {(!isED && admission?.wardId) && `${t('Last Location:')} ${admission?.wardId || ''}`}
                </span>

                <div className={clsx(classes.divRow, 'right')} style={{gap: 10}}>
                    <AgyleButton
                        variant="contained"
                        disabled={disabledAdmission || !canView || admission?.__id === null}
                        onClick={() => onOpen(admission, admission?.__id === null)}
                    >
                        {t('Review')}
                    </AgyleButton>

                    <IconButton
                        onClick={() => setExpand(!expand)}
                    >
                        {expand ? <ExpandLessIcon/> : <ExpandMoreIcon/>}
                    </IconButton>
                </div>
            </div>
        );
    };

    return (
        <div className={classes.attendanceListItem} id="attendance-list-item">
            <div className={classes.attendanceHeader}>
                {getHeader()}
            </div>

            <AttendanceTimelineHistory
                admission={admission}
                expanded={expand}
            />
        </div>
    );
};

export default HistAttendanceField;